import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import PCSwitch from './pc';
import H5Switch from './h5';

export interface SwitchProps {
    /** 是否开启 */
    checked: boolean;
    /** 状态变更回调，参数为切换后的值 */
    onChange?: (checked: boolean) => void;
    /** 是否禁用 */
    disabled?: boolean;
    /** 自定义类名 */
    className?: string;
    /** 无障碍标签 */
    'aria-label'?: string;
}

interface SwitchWrapperProps extends SwitchProps {
    app?: AppStore;
}

/** 开关组件：PC / H5 按平台自动切换样式 */
@inject('app')
@observer
class Switch extends React.Component<SwitchWrapperProps> {
    render() {
        const { app, ...props } = this.props;
        const platform = app?.platform || 'h5';

        if (platform === 'pc') {
            return <PCSwitch {...props} />;
        }
        return <H5Switch {...props} />;
    }
}

export default Switch;
